module.exports = __webpack_public_path__ + "media/assets/icons/popover-menu-25aeadd7e2a838c136396cebf1fb4b06.png";